import { useEffect, useRef, useState } from "react";

export const useDebounceValue = <T>(
  value: T,
  timeout: number,
  skipDebounce?: (value: T) => boolean,
) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (skipDebounce?.(value)) {
      setDebouncedValue(value);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      setDebouncedValue(value);
    }, timeout);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, timeout, skipDebounce]);

  return debouncedValue;
};
